import React from "react";
import { LegacyCard, InlineGrid, TextField, Select } from "@shopify/polaris";
import CustomAutocomplete from "../CustomAutocomplete";
import { ButtonNumber } from "../CoatData";

const DrawstringPantForm = ({
  form,
  setForm,
  errors,
  conditionalFieldsMap,
}) => {
  const handleChange =
    (section, key = null) =>
      (values) => {
        const trimmedKey = key?.trim();
        let value;
        if (Array.isArray(values)) {
          value = values[0];
        } else {
          value = values;
        }

        const sectionMap = conditionalFieldsMap[section];
        const fieldRule = sectionMap?.[trimmedKey];

        if (fieldRule) {
          const { conditionValue, dependentKey } = fieldRule;
          if (value === conditionValue) {
            // Add the dependent field
            setForm((prev) => ({
              ...prev,
              [section]: {
                ...prev[section],
                [trimmedKey]: value,
                [dependentKey]: "",
              },
            }));
          } else {
            // Remove the dependent field
            const updatedSection = { ...form[section] };
            delete updatedSection[dependentKey];
            updatedSection[trimmedKey] = value;

            setForm((prev) => ({
              ...prev,
              [section]: updatedSection,
            }));
          }

          return;
        }
        // Default update
        if (trimmedKey) {
          setForm((prev) => ({
            ...prev,
            [section]: {
              ...prev[section],
              [trimmedKey]: value,
            },
          }));
        } else {
          setForm((prev) => ({
            ...prev,
            [section]: value,
          }));
        }
      };

  const drawstringPantFields = [
    {
      label: "Waistband",
      key: "waistband",
      type: "select",
      options: ["Full Elastic", "Side Elastic Only"],
    },
    {
      label: "Drawstring Color",
      key: "drawstringColor",
      type: "select",
      options: [
        "White - QMD-D207-W003",
        "Light Grey- QMD-D196-W040",
        "Grey- QMD-D185- W019",
        "Dark Grey- QMD-D175-W009",
        "Brown- QMD- B067- W031",
        "Navy- QMD-B104-W035",
        "Black- QMD-BLACK-B",
      ],
    },
    {
      label: "Button Number",
      key: "buttonNumber",
      type: "select",
      options: ButtonNumber,
    },
    {
      label: "Back Pocket",
      key: "backPocket",
      type: "select",
      options: ["Besom with Button", "Besom NO Button", "No Back Pocket"],
    },
    {
      label: "Bottom Hem",
      key: "bottomHem",
      type: "select",
      options: ["Regular", "Cuff 1 3/4", "Elastic Bottom"],
    },
    {
      label: "Drawstring Holes",
      key: "drawstringHoles",
      type: "select",
      options: ["Inside Waistband", "Outside Waistband",],
    },
  ];

  const renderSection = (title, fields, sectionKey) => (
    <LegacyCard title={title} sectioned>
      <InlineGrid columns={{ xs: 1, sm: 1, md: 2, lg: 3 }} gap="300">
        {fields.map(({ label, key, type = "text", options = [] }) => {
          if (type === "select") {
            return (
              <React.Fragment key={key}>
                {key !== "fabricNumber" && (
                  <div className="two_culumn">
                    <Select
                      label={label}
                      options={options}
                      value={form[sectionKey]?.[key] || ""}
                      onChange={handleChange(sectionKey, key)}
                      error={errors[sectionKey]?.[key]}
                    />
                  </div>
                )}
                {key === "fabricNumber" && (
                  <CustomAutocomplete
                    label={label}
                    optionsList={options}
                    onChange={handleChange(sectionKey, key)}
                    defaultValue={form[sectionKey]?.[key] || ""}
                  />
                )}
              </React.Fragment>
            );
          }
          return (
            <TextField
              key={key}
              label={label}
              value={form[sectionKey]?.[key] || ""}
              onChange={handleChange(sectionKey, key)}
              error={errors[sectionKey]?.[key]}
            />
          );
        })}
      </InlineGrid>
    </LegacyCard>
  );

  return renderSection("Drawstring Pant", drawstringPantFields, "drawstringPant");
};

export default DrawstringPantForm;
